export function normaliseMoneyInput(value, decimalPlaces = 2) {
  const source = String(value ?? '').replace(/,/g, '')
  const cleaned = source.replace(/[^\d.]/g, '')
  if (!cleaned) return ''

  const decimalIndex = cleaned.indexOf('.')
  if (decimalIndex === -1) return cleaned

  const whole = cleaned.slice(0, decimalIndex) || '0'
  const fraction = cleaned.slice(decimalIndex + 1).replace(/\./g, '').slice(0, decimalPlaces)
  return `${whole}.${fraction}`
}

export function formatMoneyInput(value, decimalPlaces = 2) {
  const normalised = normaliseMoneyInput(value, decimalPlaces)
  if (!normalised) return ''

  const [whole, fraction] = normalised.split('.')
  const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return normalised.includes('.') ? `${formattedWhole}.${fraction}` : formattedWhole
}
